import { builder } from '@builder.io/react';

export async function fetchAnnouncementBanner(pathname: string) {
  const [eventsBannerRes, announcementBannerRes] = await Promise.all([
    builder
      .get('events-banner', {
        url: pathname
      })
      .promise(),
    builder
      .get('announcement-banner', {
        url: pathname
      })
      .promise()
  ]);

  return {
    eventsBanner: eventsBannerRes ?? null,
    announcementBanner: announcementBannerRes ?? null
  };
}
